import React from 'react';
import PropTypes from 'prop-types';
import { SingleSelect } from '@els/els-react--select';
import { Checkbox } from '@els/els-react--checkbox';
import HoverTooltip from '@Components/HoverTooltip/HoverTooltip';
import { ButtonWithIcon } from '@els/els-react--button';
import { TooltipConstants } from '@Components/InfoTooltip';

import { noop } from 'lodash';

import './TriggerModeRow.scss';

function TriggerModeRow({
  alertsInfo,
  alertFormTriggerMode,
  setAlertFormTriggerMode,
  // process options
  processOptionZeroResults,
  toggleProcessOptionZeroResults,
}) {
  const { triggerModes } = alertsInfo;

  const handleSelectAlertFormTriggerMode = (value) => {
    setAlertFormTriggerMode(value);
  };

  return (
    <div className="create-alert-dialog-row create-alert-dialog-row-trigger-mode">
      <div className="create-alert-dialog-column-label">Send alert:</div>
      <div className="create-alert-dialog-column-content u-els-padding-top">
        <div className="create-alert-dialog-flex-row create-alert-dialog-flex-row-trigger-mode">
          <SingleSelect
            id="create-alert-dialog-trigger-mode-dropdown"
            className="create-alert-trigger-mode e2e-create-alert-trigger-mode"
            options={triggerModes}
            selectedOptions={alertFormTriggerMode ? [alertFormTriggerMode] : undefined}
            label="Send alert"
            required
            data-e2e="create-alert-trigger-mode-dropdown"
            onSelect={handleSelectAlertFormTriggerMode}
            size="small"
            shouldHideLabel
          />
          <HoverTooltip
            width="25rem"
            placement="top-end"
            tooltip={` <ul class="info-tooltip-content-list">
              <li class="info-tooltip-content-list-item">Allows you to customise how often you receive an alert on a document:</li>
              <li class="info-tooltip-content-list-item bullet-dot">
                Upon first appearance: only receive an alert when the document that matches your query is added to Reaxys. No further alerts
                will be sent if the document is later updated or modified
              </li>
              <li class="info-tooltip-content-list-item bullet-dot">
                After any update: receive an alert when the document first appears in Reaxys and then again after any subsequent updates or
                modifications (e.g. addition or correction of a structure)
              </li>
            </ul>`}>
            <ButtonWithIcon
              iconOnly
              type="link"
              className="u-els-margin-left-1o2"
              linkIconSize="s"
              id={TooltipConstants.ids.AlertCreateDialog}
              size="small"
              data-e2e="info-tooltip-alert-triger-modes"
              e2eName="info-tooltip-alert-triger-modes"
              sprite="InformationOutlineCircle"
              onClick={() => noop()}
              a11y={{ name: 'Alert info', description: 'Alert information' }}>
              alert info
            </ButtonWithIcon>
          </HoverTooltip>
        </div>
        <div className="create-alert-dialog-flex-row">
          <Checkbox
            label={processOptionZeroResults.label}
            className="create-alert-process-option"
            data-e2e="create-alert-process-option-zero-results-checkbox"
            onChange={toggleProcessOptionZeroResults}
            checked={processOptionZeroResults.checked}
            disabled={processOptionZeroResults.disabled}
          />
          <HoverTooltip
            width="15rem"
            placement="top"
            tooltip=" Allows you to dictate if you receive email alerts even if there are no new results matching your query">
            <ButtonWithIcon
              iconOnly
              type="link"
              id={TooltipConstants.ids.AlertCreateDialog}
              linkIconSize="s"
              data-e2e="info-tooltip-alert-process-options"
              size="small"
              className="u-els-margin-left-1o2"
              e2eName="info-tooltip-alert-process-options"
              sprite="InformationOutlineCircle"
              onClick={() => noop()}
              a11y={{ name: 'Alert info', description: 'Alert information' }}>
              alert info
            </ButtonWithIcon>
          </HoverTooltip>
        </div>
      </div>
    </div>
  );
}

TriggerModeRow.propTypes = {
  alertsInfo: PropTypes.object.isRequired,
  alertFormTriggerMode: PropTypes.string,
  setAlertFormTriggerMode: PropTypes.func.isRequired,
  processOptionZeroResults: PropTypes.object.isRequired,
  toggleProcessOptionZeroResults: PropTypes.func.isRequired,
};

export default TriggerModeRow;
